var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _radialGradient, _linearGradient22, _linearGradient23, _linearGradient24, _radialGradient2, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _radialGradient3, _linearGradient44, _radialGradient4, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _linearGradient74, _linearGradient75, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _path24, _circle2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _circle3, _circle4, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _circle5, _path60, _path61, _path62, _circle6, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _circle7, _path72, _path73;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBicycle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.509,
    x2: 403.509,
    xlinkHref: "#lg1",
    y1: 155.512,
    y2: 236.035
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.062,
    x2: 106.806,
    xlinkHref: "#lg2",
    y1: 249.474,
    y2: 249.474
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(1 0 0 -1 0 453.84)",
    gradientUnits: "userSpaceOnUse",
    x1: 89.062,
    x2: 106.806,
    xlinkHref: "#lg2",
    y1: 104.978,
    y2: 104.978
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(0 1 -1 0 510 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 290.296,
    x2: 308.04,
    xlinkHref: "#lg2",
    y1: 362.372,
    y2: 362.372
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(0 1 1 0 56.16 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 290.296,
    x2: 308.04,
    xlinkHref: "#lg2",
    y1: -7.92,
    y2: -7.92
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.711 .704 -.704 .711 252.581 -105.602)",
    gradientUnits: "userSpaceOnUse",
    x1: 166.031,
    x2: 183.774,
    xlinkHref: "#lg2",
    y1: 346.743,
    y2: 346.743
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(.711 .704 .704 -.711 -66.067 217.508)",
    gradientUnits: "userSpaceOnUse",
    x1: 165.123,
    x2: 182.866,
    xlinkHref: "#lg2",
    y1: 7.67,
    y2: 7.67
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-.704 .711 -.711 -.704 615.602 252.581)",
    gradientUnits: "userSpaceOnUse",
    x1: 388.462,
    x2: 406.205,
    xlinkHref: "#lg2",
    y1: 285.381,
    y2: 285.381
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(-.704 .711 .711 .704 292.492 -66.067)",
    gradientUnits: "userSpaceOnUse",
    x1: 387.554,
    x2: 405.297,
    xlinkHref: "#lg2",
    y1: 69.032,
    y2: 69.032
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-.351 .936 .936 .351 105.598 -73.476)",
    gradientUnits: "userSpaceOnUse",
    x1: 342.707,
    x2: 360.452,
    xlinkHref: "#lg2",
    y1: 74.083,
    y2: 74.083
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-.351 .936 -.936 -.351 530.908 85.869)",
    gradientUnits: "userSpaceOnUse",
    x1: 342.981,
    x2: 360.726,
    xlinkHref: "#lg2",
    y1: 280.717,
    y2: 280.717
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(.936 .351 .351 -.936 -73.476 404.402)",
    gradientUnits: "userSpaceOnUse",
    x1: 114.629,
    x2: 132.374,
    xlinkHref: "#lg2",
    y1: 109.066,
    y2: 109.066
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(.936 .351 -.351 .936 85.869 -20.908)",
    gradientUnits: "userSpaceOnUse",
    x1: 114.903,
    x2: 132.648,
    xlinkHref: "#lg2",
    y1: 245.734,
    y2: 245.734
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(.373 .928 -.928 .373 396.329 -76.285)",
    gradientUnits: "userSpaceOnUse",
    x1: 228.091,
    x2: 245.834,
    xlinkHref: "#lg2",
    y1: 367.24,
    y2: 367.24
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(.373 .928 .928 -.373 -24.179 92.697)",
    gradientUnits: "userSpaceOnUse",
    x1: 228.244,
    x2: 245.986,
    xlinkHref: "#lg2",
    y1: -13.454,
    y2: -13.454
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(-.928 .373 -.373 -.928 586.285 396.329)",
    gradientUnits: "userSpaceOnUse",
    x1: 407.922,
    x2: 425.665,
    xlinkHref: "#lg2",
    y1: 222.682,
    y2: 222.682
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(-.928 .373 .373 .928 417.303 -24.179)",
    gradientUnits: "userSpaceOnUse",
    x1: 408.074,
    x2: 425.817,
    xlinkHref: "#lg2",
    y1: 131.104,
    y2: 131.104
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.138,
    x2: 191.73,
    xlinkHref: "#lg2",
    y1: 299.168,
    y2: 299.168
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1551,
    stopColor: "#9b489a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4019,
    stopColor: "#84438f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#5e3b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 78.467,
    cy: 258.464,
    gradientUnits: "userSpaceOnUse",
    r: 164.519,
    xlinkHref: "#lg3"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.712,
    x2: 114.157,
    xlinkHref: "#lg2",
    y1: 299.168,
    y2: 299.168
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2e3e9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518cd2"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.668,
    x2: 99.418,
    xlinkHref: "#lg4",
    y1: 305.591,
    y2: 296.841
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_26_",
    cx: 98.524,
    cy: 291.499,
    gradientUnits: "userSpaceOnUse",
    r: 18.221,
    xlinkHref: "#lg3"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.437,
    x2: 131.643,
    xlinkHref: "#lg5",
    y1: 232.908,
    y2: 220.298
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.637,
    x2: 412.381,
    xlinkHref: "#lg2",
    y1: 249.474,
    y2: 249.474
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(1 0 0 -1 0 453.84)",
    gradientUnits: "userSpaceOnUse",
    x1: 394.637,
    x2: 412.381,
    xlinkHref: "#lg2",
    y1: 104.978,
    y2: 104.978
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(0 1 -1 0 510 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 290.296,
    x2: 308.04,
    xlinkHref: "#lg2",
    y1: 56.797,
    y2: 56.797
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientTransform: "matrix(0 1 1 0 56.16 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 290.296,
    x2: 308.04,
    xlinkHref: "#lg2",
    y1: 297.656,
    y2: 297.656
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(.711 .704 -.704 .711 252.581 -105.602)",
    gradientUnits: "userSpaceOnUse",
    x1: 383.172,
    x2: 400.915,
    xlinkHref: "#lg2",
    y1: 131.742,
    y2: 131.742
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(.711 .704 .704 -.711 -66.067 217.508)",
    gradientUnits: "userSpaceOnUse",
    x1: 382.264,
    x2: 400.007,
    xlinkHref: "#lg2",
    y1: 222.671,
    y2: 222.671
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientTransform: "matrix(-.704 .711 -.711 -.704 615.602 252.581)",
    gradientUnits: "userSpaceOnUse",
    x1: 173.46,
    x2: 191.203,
    xlinkHref: "#lg2",
    y1: 68.24,
    y2: 68.24
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientTransform: "matrix(-.704 .711 .711 .704 292.492 -66.067)",
    gradientUnits: "userSpaceOnUse",
    x1: 172.552,
    x2: 190.295,
    xlinkHref: "#lg2",
    y1: 286.173,
    y2: 286.173
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientTransform: "matrix(-.351 .936 .936 .351 105.598 -73.476)",
    gradientUnits: "userSpaceOnUse",
    x1: 235.323,
    x2: 253.068,
    xlinkHref: "#lg2",
    y1: 360.176,
    y2: 360.176
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientTransform: "matrix(-.351 .936 -.936 -.351 530.908 85.869)",
    gradientUnits: "userSpaceOnUse",
    x1: 235.597,
    x2: 253.342,
    xlinkHref: "#lg2",
    y1: -5.376,
    y2: -5.376
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientTransform: "matrix(.936 .351 .351 -.936 -73.476 404.402)",
    gradientUnits: "userSpaceOnUse",
    x1: 400.722,
    x2: 418.467,
    xlinkHref: "#lg2",
    y1: 216.451,
    y2: 216.451
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientTransform: "matrix(.936 .351 -.351 .936 85.869 -20.908)",
    gradientUnits: "userSpaceOnUse",
    x1: 400.996,
    x2: 418.741,
    xlinkHref: "#lg2",
    y1: 138.35,
    y2: 138.35
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientTransform: "matrix(.373 .928 -.928 .373 396.329 -76.285)",
    gradientUnits: "userSpaceOnUse",
    x1: 342.122,
    x2: 359.864,
    xlinkHref: "#lg2",
    y1: 83.753,
    y2: 83.753
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientTransform: "matrix(.373 .928 .928 -.373 -24.179 92.697)",
    gradientUnits: "userSpaceOnUse",
    x1: 342.274,
    x2: 360.016,
    xlinkHref: "#lg2",
    y1: 270.033,
    y2: 270.033
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientTransform: "matrix(-.928 .373 -.373 -.928 586.285 396.329)",
    gradientUnits: "userSpaceOnUse",
    x1: 124.435,
    x2: 142.178,
    xlinkHref: "#lg2",
    y1: 108.652,
    y2: 108.652
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientTransform: "matrix(-.928 .373 .373 .928 417.303 -24.179)",
    gradientUnits: "userSpaceOnUse",
    x1: 124.588,
    x2: 142.33,
    xlinkHref: "#lg2",
    y1: 245.135,
    y2: 245.135
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.713,
    x2: 497.306,
    xlinkHref: "#lg2",
    y1: 299.168,
    y2: 299.168
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_49_",
    cx: 384.042,
    cy: 258.464,
    gradientUnits: "userSpaceOnUse",
    r: 164.519,
    xlinkHref: "#lg3"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.287,
    x2: 419.732,
    xlinkHref: "#lg2",
    y1: 299.168,
    y2: 299.168
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_51_",
    cx: 404.099,
    cy: 291.499,
    gradientUnits: "userSpaceOnUse",
    r: 18.221,
    xlinkHref: "#lg3"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.222,
    x2: 306.924,
    xlinkHref: "#lg5",
    y1: 333.541,
    y2: 293.943
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.74,
    x2: 409.704,
    xlinkHref: "#lg1",
    y1: 234.735,
    y2: 234.735
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.592,
    x2: 204.068,
    xlinkHref: "#lg1",
    y1: 218.476,
    y2: 230.951
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.218,
    x2: 194.78,
    xlinkHref: "#lg1",
    y1: 240.261,
    y2: 248.225
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.921,
    x2: 196.791,
    xlinkHref: "#lg1",
    y1: 215.412,
    y2: 228.61
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.036,
    x2: 147.714,
    xlinkHref: "#lg1",
    y1: 198.457,
    y2: 198.457
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.923,
    x2: 141.786,
    xlinkHref: "#lg1",
    y1: 213.647,
    y2: 220.726
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fba5c2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#fca0ba",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#ff91a5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.369,
    x2: 312.989,
    xlinkHref: "#lg6",
    y1: 234.78,
    y2: 202.63
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.308,
    x2: 406.164,
    xlinkHref: "#lg7",
    y1: 305.71,
    y2: 305.71
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.246,
    x2: 257.095,
    xlinkHref: "#lg7",
    y1: 291.024,
    y2: 291.024
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientTransform: "matrix(.707 .707 -.707 .707 189.177 -130.929)",
    gradientUnits: "userSpaceOnUse",
    x1: 348.98,
    x2: 383.693,
    xlinkHref: "#lg7",
    y1: 276.546,
    y2: 276.546
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.593,
    x2: 289.748,
    xlinkHref: "#lg7",
    y1: 305.363,
    y2: 305.363
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.896,
    x2: 266.969,
    xlinkHref: "#lg2",
    y1: 299.59,
    y2: 319.663
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.421,
    x2: 414.598,
    xlinkHref: "#lg7",
    y1: 300.388,
    y2: 300.388
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.671,
    x2: 250.82,
    xlinkHref: "#lg4",
    y1: 317.098,
    y2: 303.247
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.017,
    x2: 258.248,
    xlinkHref: "#lg2",
    y1: 332.117,
    y2: 332.117
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.761,
    x2: 258.441,
    xlinkHref: "#lg7",
    y1: 304.187,
    y2: 310.868
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.033,
    x2: 253.181,
    xlinkHref: "#lg1",
    y1: 355.979,
    y2: 368.514
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.963,
    x2: 168.483,
    xlinkHref: "#lg6",
    y1: 145.062,
    y2: 131.583
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientTransform: "matrix(.94 .341 -.341 .94 29.046 -69.509)",
    gradientUnits: "userSpaceOnUse",
    x1: 204.551,
    x2: 204.551,
    xlinkHref: "#lg2",
    y1: 139.64,
    y2: 147.604
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.64,
    x2: 322.435,
    xlinkHref: "#lg6",
    y1: 180.317,
    y2: 167.112
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.926,
    x2: 333.545,
    xlinkHref: "#lg2",
    y1: 156.873,
    y2: 159.749
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.829,
    x2: 326.829,
    xlinkHref: "#lg2",
    y1: 166.248,
    y2: 174.212
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.364,
    x2: 324.302,
    xlinkHref: "#lg4",
    y1: 158.453,
    y2: 143.39
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.611,
    x2: 337.985,
    xlinkHref: "#lg7",
    y1: 137.724,
    y2: 153.651
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.779,
    x2: 330.106,
    xlinkHref: "#lg7",
    y1: 135.063,
    y2: 144.411
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.344,
    x2: 180.66,
    xlinkHref: "#lg7",
    y1: 115.38,
    y2: 126.738
  })), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientTransform: "matrix(.946 .324 -.324 .946 25.215 -69.678)",
    gradientUnits: "userSpaceOnUse",
    x1: 202.45,
    x2: 240.971,
    xlinkHref: "#lg7",
    y1: 133.263,
    y2: 133.263
  })), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientTransform: "matrix(.946 .324 -.324 .946 25.215 -69.678)",
    gradientUnits: "userSpaceOnUse",
    x1: 228.364,
    x2: 240.971,
    xlinkHref: "#lg7",
    y1: 133.263,
    y2: 133.263
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m300.809 265.383c1.595 0 2.995-1.013 3.544-2.511 14.804-40.432 53.597-69.299 99.157-69.299s84.353 28.867 99.157 69.299c.549 1.498 1.948 2.511 3.544 2.511 2.624 0 4.459-2.616 3.558-5.08-15.851-43.327-57.442-74.251-106.258-74.251-48.817 0-90.407 30.925-106.259 74.251-.903 2.464.933 5.08 3.557 5.08z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m106.806 292.101h-17.744l3.314-85.254h11.116zm-15.903-1.77h14.063l-3.176-81.715h-7.712z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m103.492 391.489h-11.116l-3.314-85.254h17.744zm-9.414-1.77h7.712l3.176-81.715h-14.063z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m105.001 308.04v-17.744l85.254 3.314v11.116zm1.77-15.904v14.063l81.715-3.176v-7.712z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m90.867 308.04-85.254-3.314v-11.116l85.254-3.314zm-83.484-5.017 81.715 3.176v-14.063l-81.715 3.176v7.711z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m106.806 292.101h-17.744l3.314-85.254h11.116zm-15.903-1.77h14.063l-3.176-81.715h-7.712z",
    fill: "url(#SVGID_2_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m103.492 391.489h-11.116l-3.314-85.254h17.744zm-9.414-1.77h7.712l3.176-81.715h-14.063z",
    fill: "url(#SVGID_3_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m105.001 308.04v-17.744l85.254 3.314v11.116zm1.77-15.904v14.063l81.715-3.176v-7.712z",
    fill: "url(#SVGID_4_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m90.867 308.04-85.254-3.314v-11.116l85.254-3.314zm-83.484-5.017 81.715 3.176v-14.063l-81.715 3.176v7.711z",
    fill: "url(#SVGID_5_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m109.21 300.388-12.609-12.483 62.337-58.255 7.898 7.821zm-10.056-12.447 9.994 9.894 55.234-60.304-5.48-5.426z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m36.93 368.686-7.898-7.821 57.626-62.917 12.609 12.483zm-5.444-7.881 5.48 5.426 59.748-55.836-9.994-9.895z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m159.631 368.07-62.917-57.626 12.483-12.608 58.255 62.337zm-60.364-57.688 60.304 55.234 5.426-5.48-55.836-59.748z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m86.671 300.5-58.255-62.337 7.821-7.898 62.917 57.626zm-55.799-62.3 55.836 59.748 9.894-9.994-60.305-55.234z",
    fill: "url(#SVGID_13_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m88.201 304.991-78.654-33.061 3.907-10.407 80.982 26.855zm-76.399-34.032 75.388 31.687 4.942-13.167-77.62-25.74z",
    fill: "url(#SVGID_14_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m182.415 336.812-80.982-26.855 6.235-16.613 78.654 33.061zm-78.678-27.956 77.62 25.74 2.71-7.22-75.388-31.687z",
    fill: "url(#SVGID_15_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m70.697 387.555-10.407-3.907 26.855-80.982 16.613 6.235zm-8.191-4.965 7.22 2.71 31.687-75.388-13.167-4.942z",
    fill: "url(#SVGID_16_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m108.724 295.669-16.613-6.235 33.061-78.654 10.407 3.907zm-14.268-7.246 13.167 4.942 25.74-77.62-7.22-2.71z",
    fill: "url(#SVGID_17_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m107.801 304.761-6.621-16.461 80.332-28.74 4.149 10.313zm-4.293-15.414 5.249 13.047 74.626-33.44-2.877-7.154z",
    fill: "url(#SVGID_18_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m14.356 338.776-4.149-10.313 77.86-34.888 6.621 16.462zm-1.871-9.394 2.877 7.154 76.998-27.548-5.249-13.047z",
    fill: "url(#SVGID_19_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m127.229 386.894-34.888-77.86 16.462-6.621 28.74 80.332zm-32.521-76.904 33.44 74.626 7.154-2.877-27.548-76.998z",
    fill: "url(#SVGID_20_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m87.066 295.922-28.74-80.332 10.313-4.149 34.888 77.86zm-26.5-79.326 27.548 76.998 13.047-5.249-33.44-74.626z",
    fill: "url(#SVGID_21_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m97.934 205.372c-51.802 0-93.796 41.994-93.796 93.796s41.994 93.796 93.796 93.796 93.796-41.994 93.796-93.796-41.994-93.796-93.796-93.796zm0 172.786c-43.625 0-78.99-35.365-78.99-78.99s35.365-78.99 78.99-78.99 78.99 35.365 78.99 78.99-35.365 78.99-78.99 78.99z",
    fill: "url(#SVGID_22_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m97.934 201.234c-54.087 0-97.934 43.846-97.934 97.934s43.847 97.934 97.934 97.934c54.088 0 97.934-43.846 97.934-97.934s-43.846-97.934-97.934-97.934zm0 180.409c-45.55 0-82.475-36.925-82.475-82.475s36.925-82.475 82.475-82.475 82.475 36.925 82.475 82.475c0 45.549-36.925 82.475-82.475 82.475z",
    fill: "url(#SVGID_23_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.934,
    cy: 299.168,
    fill: "url(#SVGID_24_)",
    r: 16.223
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m102.827 283.7-8.537 22.535 8.435 8.435c6.62-2.044 11.432-8.21 11.432-15.502 0-7.254-4.762-13.392-11.33-15.468z",
    fill: "url(#SVGID_25_)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.934,
    cy: 299.168,
    fill: "url(#SVGID_26_)",
    r: 7.952
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m137.748 209.696-7.689 17.313c13.428 5.988 24.881 15.599 33.1 27.609l11.953-15.699c-9.818-12.56-22.626-22.655-37.364-29.223z",
    fill: "url(#SVGID_27_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m412.381 292.101h-17.744l3.314-85.254h11.116zm-15.903-1.77h14.063l-3.176-81.715h-7.711z",
    fill: "url(#SVGID_28_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m409.067 391.489h-11.116l-3.314-85.254h17.744zm-9.413-1.77h7.711l3.176-81.715h-14.063z",
    fill: "url(#SVGID_29_)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m410.576 308.04v-17.744l85.254 3.314v11.116zm1.77-15.904v14.063l81.715-3.176v-7.712z",
    fill: "url(#SVGID_30_)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m396.442 308.04-85.254-3.314v-11.116l85.254-3.314zm-83.484-5.017 81.715 3.176v-14.063l-81.715 3.176z",
    fill: "url(#SVGID_31_)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m412.381 292.101h-17.744l3.314-85.254h11.116zm-15.903-1.77h14.063l-3.176-81.715h-7.711z",
    fill: "url(#SVGID_28_)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m409.067 391.489h-11.116l-3.314-85.254h17.744zm-9.413-1.77h7.711l3.176-81.715h-14.063z",
    fill: "url(#SVGID_29_)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m410.576 308.04v-17.744l85.254 3.314v11.116zm1.77-15.904v14.063l81.715-3.176v-7.712z",
    fill: "url(#SVGID_30_)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m396.442 308.04-85.254-3.314v-11.116l85.254-3.314zm-83.484-5.017 81.715 3.176v-14.063l-81.715 3.176z",
    fill: "url(#SVGID_31_)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m414.785 300.388-12.609-12.483 62.337-58.255 7.898 7.821zm-10.056-12.447 9.994 9.894 55.234-60.304-5.48-5.426z",
    fill: "url(#SVGID_36_)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m342.505 368.686-7.898-7.821 57.626-62.917 12.609 12.483zm-5.444-7.881 5.48 5.426 59.748-55.836-9.994-9.894z",
    fill: "url(#SVGID_37_)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m465.207 368.07-62.917-57.626 12.483-12.608 58.255 62.337zm-60.365-57.688 60.304 55.234 5.426-5.48-55.836-59.748z",
    fill: "url(#SVGID_38_)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m392.246 300.5-58.255-62.337 7.821-7.898 62.917 57.626zm-55.799-62.3 55.836 59.748 9.894-9.994-60.304-55.234z",
    fill: "url(#SVGID_39_)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m393.776 304.991-78.654-33.061 3.907-10.407 80.982 26.855zm-76.399-34.032 75.388 31.687 4.942-13.167-77.62-25.74z",
    fill: "url(#SVGID_40_)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m487.99 336.812-80.982-26.855 6.235-16.613 78.654 33.061zm-78.678-27.956 77.62 25.74 2.71-7.22-75.388-31.687z",
    fill: "url(#SVGID_41_)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m376.272 387.555-10.407-3.907 26.855-80.982 16.613 6.235zm-8.191-4.965 7.22 2.71 31.687-75.388-13.167-4.942z",
    fill: "url(#SVGID_42_)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m414.299 295.669-16.613-6.235 33.061-78.654 10.407 3.907zm-14.268-7.246 13.167 4.942 25.74-77.62-7.22-2.71z",
    fill: "url(#SVGID_43_)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m413.376 304.761-6.621-16.462 80.332-28.74 4.149 10.313zm-4.293-15.414 5.249 13.047 74.626-33.44-2.877-7.154z",
    fill: "url(#SVGID_44_)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m319.931 338.776-4.149-10.313 77.86-34.888 6.621 16.462zm-1.87-9.394 2.877 7.154 76.998-27.548-5.249-13.047z",
    fill: "url(#SVGID_45_)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m432.804 386.894-34.888-77.86 16.462-6.621 28.74 80.332zm-32.52-76.904 33.44 74.626 7.154-2.877-27.548-76.998z",
    fill: "url(#SVGID_46_)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m392.641 295.922-28.74-80.332 10.313-4.149 34.888 77.86zm-26.5-79.326 27.548 76.998 13.047-5.249-33.44-74.626z",
    fill: "url(#SVGID_47_)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m403.509 205.372c-51.802 0-93.796 41.994-93.796 93.796s41.994 93.796 93.796 93.796 93.796-41.994 93.796-93.796-41.993-93.796-93.796-93.796zm0 172.786c-43.625 0-78.99-35.365-78.99-78.99s35.365-78.99 78.99-78.99 78.99 35.365 78.99 78.99-35.365 78.99-78.99 78.99z",
    fill: "url(#SVGID_48_)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m403.509 201.234c-54.087 0-97.934 43.846-97.934 97.934s43.847 97.934 97.934 97.934c54.088 0 97.934-43.846 97.934-97.934s-43.846-97.934-97.934-97.934zm0 180.409c-45.55 0-82.475-36.925-82.475-82.475s36.925-82.475 82.475-82.475 82.475 36.925 82.475 82.475c0 45.549-36.925 82.475-82.475 82.475z",
    fill: "url(#SVGID_49_)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.509,
    cy: 299.168,
    fill: "url(#SVGID_50_)",
    r: 16.223
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.509,
    cy: 299.168,
    fill: "url(#SVGID_51_)",
    r: 7.952
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m305.803 305.524 25.364 25.364c-3.821-8.701-6.123-18.217-6.559-28.222h-18.944c.033.957.078 1.909.139 2.858z",
    fill: "url(#SVGID_52_)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m403.51 305.362h-150.576c-2.21 0-4.253-1.178-5.36-3.09-1.108-1.913-1.112-4.271-.011-6.188l73.984-128.864c1.703-2.966 5.488-3.99 8.456-2.287 2.967 1.703 3.991 5.489 2.287 8.456l-14.449 25.167 90.193 96.383c1.686 1.802 2.14 4.433 1.159 6.696-.983 2.262-3.215 3.727-5.683 3.727zm-139.877-12.389h125.602l-77.828-83.213z",
    fill: "url(#SVGID_53_)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m189.256 236.671c-1.585 0-3.171-.605-4.38-1.814-2.419-2.419-2.419-6.341 0-8.76l14.338-14.338c2.42-2.418 6.341-2.418 8.761 0 2.419 2.42 2.419 6.341 0 8.761l-14.338 14.338c-1.21 1.208-2.796 1.813-4.381 1.813z",
    fill: "url(#SVGID_54_)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m252.936 305.362c-1.664 0-3.323-.666-4.544-1.983l-104.044-112.235c-2.325-2.509-2.177-6.427.332-8.754 2.508-2.327 6.426-2.178 8.754.332l104.043 112.234c2.325 2.509 2.177 6.427-.332 8.754-1.192 1.105-2.703 1.652-4.209 1.652z",
    fill: "url(#SVGID_55_)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m274.613 263.466h-9.562c-18.015 0-35.103-8.117-48.115-22.855l-61.658-70.073c-2.265-2.565-2.021-6.478.544-8.742 2.566-2.266 6.481-2.02 8.742.544l61.658 70.073c10.628 12.036 24.417 18.665 38.829 18.665h9.562c3.421 0 6.194 2.773 6.194 6.194s-2.773 6.194-6.194 6.194z",
    fill: "url(#SVGID_56_)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m147.714 194.57c-14.1-6.767-29.737-10.786-46.223-11.279-29.003-.868-55.697 8.922-76.463 25.743-2.534 2.053.27 5.934 3.041 4.214 18.463-11.457 40.38-17.872 63.838-17.31 17.607.422 34.281 4.859 49.162 12.395z",
    fill: "url(#SVGID_57_)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m97.93 305.363c-.856 0-1.727-.179-2.557-.556-3.115-1.415-4.493-5.086-3.08-8.201l74.329-163.713c1.415-3.115 5.087-4.491 8.201-3.08 3.115 1.415 4.493 5.086 3.08 8.201l-74.329 163.713c-1.037 2.286-3.289 3.636-5.644 3.636z",
    fill: "url(#SVGID_58_)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m311.407 209.76 37.144 39.714h16.939l-47.649-50.92z",
    fill: "url(#SVGID_59_)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m262.823 339.136-1.082-5.197 139.114-28.978v-6.978l-148.547-20.44.724-5.259 153.132 21.07v15.924z",
    fill: "url(#SVGID_60_)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m248.246 276.684h8.849v28.681h-8.849z",
    fill: "url(#SVGID_61_)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m234.377 329.912-6.257-6.257 24.55-24.551 24.546 24.547-6.256 6.256-18.29-18.288z",
    fill: "url(#SVGID_62_)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m260.704 341.162c-2.383.001-4.737-.767-6.685-2.241-.794-.599-1.903-.602-2.695-.001-2.889 2.182-6.669 2.816-10.111 1.699-3.441-1.118-6.123-3.852-7.176-7.314-.285-.937-1.161-1.583-2.138-1.583-.001 0-.002 0-.002 0l-.051.001c-3.629.111-7.043-1.64-9.169-4.564-2.126-2.925-2.691-6.712-1.511-10.129.328-.952-.014-2.004-.827-2.573-2.978-2.083-4.746-5.478-4.746-9.092s1.768-7.009 4.729-9.08c.83-.58 1.172-1.631.849-2.569-1.184-3.434-.619-7.222 1.507-10.146 2.127-2.924 5.571-4.651 9.169-4.564 1 .049 1.902-.632 2.19-1.582 1.053-3.463 3.737-6.197 7.178-7.316 3.442-1.118 7.219-.483 10.106 1.7.794.599 1.903.602 2.695.001 2.889-2.183 6.67-2.818 10.109-1.7 3.441 1.118 6.124 3.852 7.177 7.314.289.952 1.221 1.612 2.178 1.584 3.623-.093 7.055 1.637 9.181 4.562 2.127 2.925 2.693 6.712 1.513 10.13-.328.954.013 2.006.825 2.573 2.979 2.083 4.747 5.478 4.747 9.092 0 3.615-1.768 7.01-4.73 9.082l-.054.037c-.775.542-1.117 1.594-.794 2.532 1.185 3.434.62 7.221-1.506 10.145-2.127 2.925-5.568 4.672-9.169 4.564-.955.003-1.901.632-2.19 1.583-1.053 3.462-3.737 6.197-7.178 7.315-1.119.362-2.273.54-3.421.54zm-28.806-18.289c4.847 0 9.19 3.205 10.605 7.856.295.971 1.033 1.341 1.446 1.476s1.229.266 2.037-.343c3.937-2.973 9.432-2.974 13.366-.002.81.611 1.626.478 2.039.344.414-.134 1.151-.505 1.447-1.473 1.434-4.716 5.877-7.985 10.807-7.855 1.043.026 1.605-.569 1.861-.919.256-.352.635-1.085.305-2.041-1.61-4.67.086-9.889 4.118-12.71l.016-.012c.83-.58.954-1.396.954-1.83s-.124-1.249-.953-1.829c-4.05-2.833-5.746-8.053-4.141-12.707.335-.972-.044-1.705-.3-2.057-.251-.346-.817-.918-1.799-.918-.088 0-.17.002-.253.002-4.86.001-9.201-3.205-10.616-7.857-.295-.97-1.033-1.34-1.446-1.475-.413-.136-1.229-.268-2.037.343-3.935 2.975-9.43 2.975-13.365.002-.811-.613-1.626-.478-2.039-.344-.414.134-1.151.505-1.446 1.473-1.434 4.715-5.87 7.942-10.807 7.855-1.045.001-1.605.569-1.86.919-.256.352-.635 1.085-.305 2.042 1.611 4.667-.085 9.887-4.118 12.709-.847.592-.97 1.408-.97 1.841 0 .435.124 1.25.953 1.831 4.05 2.833 5.747 8.053 4.141 12.705-.335.972.044 1.705.299 2.056.252.346.818.92 1.801.92h.005l.055-.001c.066-.001.133-.001.2-.001z",
    fill: "url(#SVGID_63_)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.67,
    cy: 305.364,
    fill: "url(#SVGID_64_)",
    r: 12.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m413.262 302.022-.02.004c-1.271.258-1.774 1.805-.897 2.761l.013.014c1.228 1.339-.268 3.398-1.921 2.643l-.017-.008c-1.181-.539-2.497.418-2.349 1.707.208 1.806-2.214 2.593-3.108 1.01l-.001-.003c-.638-1.13-2.266-1.13-2.904 0l-.002.003c-.894 1.583-3.316.796-3.108-1.01.148-1.289-1.168-2.246-2.349-1.707l-.017.008c-1.653.755-3.15-1.304-1.921-2.643l.012-.014c.877-.956.374-2.503-.897-2.761l-.02-.004c-1.781-.361-1.781-2.906 0-3.268l.02-.004c1.271-.258 1.774-1.805.897-2.761l-.013-.014c-1.228-1.339.268-3.398 1.921-2.643l.017.008c1.18.539 2.497-.418 2.349-1.707-.208-1.806 2.214-2.593 3.108-1.01l.001.003c.638 1.13 2.266 1.13 2.904 0l.002-.003c.894-1.583 3.316-.796 3.108 1.01v.001c-.148 1.289 1.168 2.246 2.349 1.707l.017-.008c1.653-.755 3.15 1.304 1.921 2.643l-.012.014c-.877.956-.374 2.503.897 2.761l.02.004c1.781.36 1.781 2.906 0 3.267z",
    fill: "url(#SVGID_65_)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m257.836 301.335c-1.161-1.328-2.859-2.167-4.761-2.167-3.495 0-6.335 2.834-6.335 6.335 0 1.902.846 3.6 2.167 4.761l7.13 7.128c4.333-1.211 7.708-4.692 8.77-9.085z",
    fill: "url(#SVGID_66_)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m250.107 306.235h5.937v51.764h-5.937z",
    fill: "url(#SVGID_67_)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.075,
    cy: 305.502,
    fill: "url(#SVGID_68_)",
    r: 6.333
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m261.22 364.636h-16.289c-2.507 0-4.539-2.032-4.539-4.539v-1.099c0-2.507 2.032-4.539 4.539-4.539h16.289c2.507 0 4.539 2.032 4.539 4.539v1.099c-.001 2.507-2.033 4.539-4.539 4.539z",
    fill: "url(#SVGID_69_)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m174.823 129.814c-3.113-1.411-6.786-.035-8.201 3.08l-1.717 3.782 9.357 9.357 3.64-8.018c1.415-3.115.037-6.786-3.079-8.201z",
    fill: "url(#SVGID_70_)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m176.01 140.831-10.149-3.687c-2.603-.946-3.947-3.822-3.001-6.425.946-2.603 3.822-3.947 6.425-3.001l10.149 3.687c2.603.946 3.947 3.822 3.001 6.425-.945 2.603-3.822 3.947-6.425 3.001z",
    fill: "url(#SVGID_71_)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m332.29 173.387c1.703-2.967.679-6.752-2.287-8.456-2.967-1.702-6.752-.679-8.456 2.287l-3.304 5.755 9.074 9.074z",
    fill: "url(#SVGID_72_)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m330.846 172.433-10.336-2.43 6.009-25.571 10.337 2.43z",
    fill: "url(#SVGID_73_)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m332.227 174.138h-10.797c-2.77 0-5.015-2.245-5.015-5.015 0-2.77 2.245-5.015 5.015-5.015h10.798c2.77 0 5.015 2.245 5.015 5.015-.001 2.77-2.246 5.015-5.016 5.015z",
    fill: "url(#SVGID_74_)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m324.567 152.738 8.832 8.832 3.457-14.708-10.337-2.43z",
    fill: "url(#SVGID_75_)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m301.194 148.856c5.816 2.73 12.162 4.145 18.586 4.145h4.243c9.575 0 18.886-3.142 26.503-8.944l11.015-8.389c3.564-2.715 1.645-8.404-2.836-8.404h-9.448c-5.329 0-10.551 1.493-15.075 4.309-3.155 1.964-6.664 3.293-10.33 3.911l-21.322 3.598c-4.994.843-5.921 7.622-1.336 9.774z",
    fill: "url(#SVGID_76_)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m314.497 142.92c19.396 0 35.351-6.859 37.316-15.655h-2.555c-5.329 0-10.551 1.493-15.075 4.309-3.155 1.964-6.664 3.293-10.33 3.912l-21.322 3.597c-1.591.268-2.765 1.142-3.484 2.274 4.716.995 9.936 1.563 15.45 1.563z",
    fill: "url(#SVGID_77_)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.175,
    cy: 123.344,
    fill: "url(#SVGID_78_)",
    r: 10.445
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m201.47 138.624-23.591-8.067c-3.551-1.214-5.445-5.077-4.231-8.628 1.214-3.551 5.077-5.445 8.628-4.23l23.591 8.068c3.551 1.214 5.445 5.077 4.231 8.628-1.214 3.549-5.077 5.443-8.628 4.229z",
    fill: "url(#SVGID_79_)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m201.47 138.624.929.318c-3.551-1.214-5.445-5.077-4.231-8.628 1.214-3.551 5.077-5.445 8.628-4.231l-.929-.318c3.551 1.214 5.445 5.077 4.231 8.628-1.214 3.551-5.077 5.445-8.628 4.231z",
    fill: "url(#SVGID_80_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBicycle);
export default __webpack_public_path__ + "static/media/icon-bicycle.4539b0ad147eefb44a2640e54e27be5f.svg";
export { ForwardRef as ReactComponent };